
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import '../styles/RegisterPartnerSummary.css';
import { sociasStore } from '../services/sociasStore';

const RegisterPartnerSummary = () => {
    const navigate = useNavigate();
    const [partnerCode, setPartnerCode] = useState('');
    const location = useLocation();

    useEffect(() => {
        const codeFromState = location?.state?.partnerCode;
        if (codeFromState) {
            setPartnerCode(codeFromState);
            return;
        }
        // Fallback: tomar el último elemento del store
        const list = sociasStore.getAll();
        if (list.length > 0) setPartnerCode(list[list.length - 1].id);
    }, [location]);

    const handleFinish = () => {
        navigate('/dashboard'); // O a donde corresponda después del registro
    };

    return (
        <div className="register-summary-container">
            <div className="register-summary-content">
                <div className="success-message">
                    <h2>¡Registro Exitoso!</h2>
                    <p>La socia ha sido registrada correctamente en el sistema</p>
                </div>

                {partnerCode ? (
                    <div className="partner-code-result">
                        <p>Código asignado:</p>
                        <span className="partner-code-display">{partnerCode}</span>
                    </div>
                ) : (
                    <div className="generating-code">
                        <p>Generando código de socia...</p>
                        {/* Aquí podrías agregar un spinner de carga */}
                    </div>
                )}

                <button onClick={handleFinish} className="finish-button">
                    FINALIZAR
                </button>
            </div>
        </div>
    );
};

export default RegisterPartnerSummary;